import './App.css'
import './css/grid.css'
import './css/toast.css'
import { useEffect, useState } from 'react'
import { Header, Menu, AppLoadingBar } from 'components'
import { Router } from 'components'
import axios from 'axios'
import packageJson from '../package.json'
import { ThemeProvider } from 'styled-components'
import { ITheme, darkTheme, lightTheme, } from './theme/theme'
import { GlobalStyles } from './global'
import { useDispatch, useSelector } from 'react-redux'
import { appInitialize, appLoadedSuccess } from 'state/actions/appActions'
import { AppDispatch } from 'state/store'
import { IRootState } from 'types'
import { setupInterceptors } from 'core/http-common'
import { ToastContainer } from 'react-toastify'

const App = () => {
  setupInterceptors()

  const dispatch = useDispatch<AppDispatch>()
  const [serverName, setserverName] = useState('')
  const authenticated = useSelector((state: IRootState) => state.user.authenticated)
  const appLoaded = useSelector((state: IRootState) => state.app.loaded)

  // on app load -- verifytoken and load session data
  useEffect(() => {
    (async () => {
      getHeaders()
      if (location.pathname !== process.env.REACT_APP_LOGIN_REDIRECT) {
        await dispatch(appInitialize())
      }
      else //login page is the only page that is unauthenticated
        dispatch(appLoadedSuccess())
    }
    )()
  }, [])

  async function getHeaders() {
    await axios.get('/index.html')
      .then(res => {
        setserverName(res.headers['x-machine-name'])
      })
  }

  const [theme, setTheme] = useState<ITheme>(lightTheme)
  const [loadingTheme, setLoadingTheme] = useState<boolean>(true)

  useEffect(() => {
    const storedTheme = localStorage.getItem('theme')
    if (storedTheme && authenticated) {
      setTheme(storedTheme === 'dark' ? darkTheme : lightTheme)
    }
    setLoadingTheme(false)
  }, [authenticated])

  const buildMetadata = `
  <!--
    Server Name: ${serverName} 
    Build Number: ${packageJson.version}
  -->`

  if (loadingTheme) {
    return <></>
  }
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles theme={theme} />
      <link rel='stylesheet' href={theme === lightTheme ? '/css/light.css' : '/css/dark.css'}></link>
      <div>
        <div className='hidden-print'>
          <AppLoadingBar />
        </div>

        {appLoaded && location.pathname !== process.env.REACT_APP_LOGIN_REDIRECT && <Header theme={theme} themeChanged={(theme: ITheme) => setTheme(theme)} />}

        {appLoaded && authenticated && location.pathname !== process.env.REACT_APP_LOGIN_REDIRECT ? <Menu /> : <></>}

        {appLoaded ? <Router /> : <></>}

        <div dangerouslySetInnerHTML={{ __html: buildMetadata }} />
      </div>
      <ToastContainer />
    </ThemeProvider>
  )
}

export default App
